module.exports = __webpack_public_path__ + "static/media/RAA_AlertingImage_221206_RedAccent.816e8ee0.png";